import { EmploymentViewModel, PayReportingTableRowViewModelOld } from '@fora-monorepo/employer-my-pages-common/types';
import { isPensionParameter } from '@fora-monorepo/employer-my-pages-common/utils';
import { isFuture, isTodayOrFuture } from '@fora-monorepo/date-utils';
import { Assets, Box, Flex, Table, Text, Tooltip } from '@foradevelopment/fora-ui';
import { numberToText } from '@fora-monorepo/webapp-i18n';

import { getParameterTKeys } from '../../common/utils';
import { useTypedTranslation } from '../../i18n/i18n';

// TODO: REMOVE FILE MANAGE EMPLOYMENTS

export const EmploymentTableRowIconCellOld = ({
  employment,
  payMonthMargin,
  stopPropagation = false,
}: {
  employment: EmploymentViewModel | PayReportingTableRowViewModelOld;
  payMonthMargin: number;
  stopPropagation?: boolean;
}) => {
  const { t, i18n } = useTypedTranslation();

  if (employment.isInactive && !isTodayOrFuture(employment.employmentStartDate)) {
    const InactiveTooltipContent = () => {
      return (
        <Flex flexDirection="column" rowGap={10}>
          <Text color="black90" fontWeight="semibold">
            {t('tooltips.inactiveMarkup.title')}
          </Text>
          <Text color="black90">
            {t('tooltips.inactiveMarkup.description', {
              payMonthMarginText: numberToText(payMonthMargin, i18n.language),
            })}
          </Text>
        </Flex>
      );
    };
    return (
      <Table.Cell>
        <Tooltip
          id={`tooltip-icon-cell-employee-${employment.policyNumber}`}
          content={<InactiveTooltipContent />}
          openOnHover={true}
          size="small"
          isInTable={true}
          variant="object"
        >
          <Assets.StopIcon color="black80" />
        </Tooltip>
      </Table.Cell>
    );
  }

  if (employment.activeMarkup?.fokParameterChoices && employment.activeMarkup?.fokParameterChoices?.length > 0) {
    const TooltipContent = () => {
      return (
        <Flex flexDirection="column" rowGap={10}>
          {employment.activeMarkup?.fokParameterChoices?.map(({ parameterValue, startDate, endDate }, index) => {
            const { name, description } = getParameterTKeys(parameterValue);
            return (
              <Box key={index}>
                <Text color="black90" fontWeight="semibold" marginBottom={2} size="small">
                  {t(name)}
                </Text>
                <Text color="black90" size="small">
                  {t(description)}
                </Text>
                {!isPensionParameter(parameterValue) && isFuture(startDate) && (
                  <Text color="black90" marginTop={15}>
                    {t('common.startDate')}: {startDate}
                  </Text>
                )}
                {endDate && (
                  <Text color="black90" marginTop={15} size="small">
                    {t('common.endDate')}: {endDate}
                  </Text>
                )}
              </Box>
            );
          })}
        </Flex>
      );
    };

    return (
      <Table.Cell>
        <Tooltip
          id={`tooltip-icon-cell-employee-${employment.policyNumber}`}
          content={<TooltipContent />}
          openOnHover={true}
          size="small"
          isInTable={true}
          variant="object"
          stopPropagation={stopPropagation}
        >
          <Assets.BellIcon color="black80" />
        </Tooltip>
      </Table.Cell>
    );
  }
  return <Table.Cell />;
};
